<template>
  <article>
    <action-sheet
      class="action-sheet"
      :opened.sync="opened"
      title="MCOM-0000076"
      confirm="MCOM-0000077"
      cancel="MCOM-0000078"
      @confirm="otpOpen"
    >
      <template #content>
        <approval-certification ref="approval" :corp-bzwk-cd="corpBzwkCd" />
      </template>
    </action-sheet>

    <suppl-certn
      ref="supplCertn"
      :NOS_INSTANCE_REFERANCE="NOS_INSTANCE_REFERANCE"
      :scurtyDeviVndrDstcd="this.scurtyDeviVndrDstcd"
    />
  </article>
</template>

<script>
import ApprovalCertification from "@/components/page/common/ApprovalCertification";
import SupplCertn from "@/components/page/common/SupplCertn";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
export default {
  name: "ApprovalLine",
  components: {
    ApprovalCertification,
    SupplCertn,
  },
  props: {
    NOS_INSTANCE_REFERANCE: {
      required: false,
      default: () => undefined,
    },
    scurtyDeviVndrDstcd: String,
    corpBzwkCd: String,
    corpBzwkCdYN: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      opened: false,
      memo: "",
    };
  },
  computed: {
    ...mapGetters(["getSessionCoprDstcd"]),
    ...mapGetters("common/supplCertn", ["getSupplCertn"]),
    ...mapFields("admin", ["approvalLineInfo"]),
  },
  methods: {
    approvalCertificationCall() {
      // if (!this.$refs.otp.$v.$invalid) {
      //   this.$emit("confirm", this.$refs.otp.json);
      // }
    },
    open() {
      //기업 && !단독결재 일때만, 결재선 보여주기
      if (this.getSessionCoprDstcd == this.$config.USERTYPE_CORP && this.approvalLineInfo.aprvalSngleYn == "결재선" && this.corpBzwkCdYN == true) {
        this.opened = true;
      } else {
        this.otpOpen();
      }
    },

    otpOpen() {
      if (this.getSessionCoprDstcd == this.$config.USERTYPE_CORP && this.approvalLineInfo.aprvalSngleYn == "결재선" && this.corpBzwkCdYN == true) {
        this.memo = this.$refs.approval.memo;
      }
      this.$emit("authOpen");
    },
  },
};
</script>
